module.exports = "/fonts/Roboto-Bold.ttf?16d7bb99c6f81cacdd91cd92d8ddb545";